import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IInitialStateStudents} from "../types";
import {GetStudents} from "./thunk";

const initialState: IInitialStateStudents = {
    students: [],
    isLoadingStudents: true,
    selectedStudentsIDs:[],
    isViewStudentsRestore:false,
    studentsRestore:[]
}


const studentsSlice = createSlice({
    name: "students",
    initialState,
    reducers: {
        setStudents: (state, action) => {
            state.students = action.payload
        },
        deleteStudents: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            state.students = state.students.filter(
                (elem) => elem.id !== id
            );

        },
        setSelectedStudentsIDs: (state, action) => {
            state.selectedStudentsIDs = action.payload;
        },
        setIsViewStudentsRestore: (state) => {
            state.isViewStudentsRestore = !state.isViewStudentsRestore;
        },
        setStudentsRestore: (state, action) => {
            state.studentsRestore = action.payload;
        },

        deletedRestoreStudents: (state, action) => {
            state.studentsRestore = state.studentsRestore.filter(
                (elem) => elem.id !== action.payload
            );

        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetStudents.pending, (state) => {
                state.isLoadingStudents = true;
            })
            .addCase(GetStudents.fulfilled,(state) => {
                    state.isLoadingStudents = false;
                }
            )
            .addCase(GetStudents.rejected, (state) => {
                state.isLoadingStudents = false;
            })
    }
})

export const {
    setStudents,
    deleteStudents,
    setSelectedStudentsIDs,
    setIsViewStudentsRestore,
    deletedRestoreStudents,
    setStudentsRestore
} = studentsSlice.actions


export default studentsSlice